import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import * as Actions from '../../actions/actions';

const RouteDetailsGridPanel = ({ allRouteDetailsData, filters, filterOptions, customers }) => {

    const filteredData = useMemo(() => {
        if (!allRouteDetailsData || allRouteDetailsData.length === 0) return [];
        const rows = filters.route && filters.route.id
            ? allRouteDetailsData.filter(row => row.route_system_id === filters.route.id)
            : allRouteDetailsData;

        return rows.map(row => ({
            ...row,
            filter_date: row.scan_date || '',
            filter_customer: (() => {
                const c = (customers || []).find(c => c.customer_id === filters.customer);
                return c ? c.customer_name : (filters.customer || '');
            })(),
            filter_dc: row.dc_name || filters.dc || ''
        }));
    }, [allRouteDetailsData, filters, customers]);

    const columns = [
        { field: 'filter_date', headerName: 'Date', width: 110, valueFormatter: (params) => {
            if (!params.value) return '';
            const [y, m, d] = params.value.split('-');
            return `${m}-${d}-${y}`;
        } },
        { field: 'filter_customer', headerName: 'Customer', width: 160 },
        { field: 'filter_dc', headerName: 'DC', width: 160 },
        { field: 'local_route', headerName: 'Route', width: 100 },
        { field: 'stop_number', headerName: 'Stop Number', width: 130, type: 'number' },
        { field: 'store_name', headerName: 'Stop Name', width: 180 },
        { field: 'pallet_number', headerName: 'Pallet ID', width: 120 },
        { field: 'dock_door', headerName: 'Planned Door', width: 130 },
        { field: 'door_detected', headerName: 'Door Detected', width: 130 },
        { field: 'loaded_stop_number', headerName: 'Order Through Door', width: 160, type: 'number' },
        { field: 'operation_time_local', headerName: 'Last Read Time', width: 180 },
        { field: 'status', headerName: 'Door Status', width: 120 },
        { field: 'sequence_status', headerName: 'Sequence Status', width: 140 }
    ];

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: "100%" }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>ROUTE-CENTRIC DETAILS</h3>
                </div>
                <div className="duolift-device-detail-card-body">
                    <div style={{ height: '440px', width: '100%' }}>
                        <DataGrid
                            rows={filteredData}
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            paginationMode="client"
                            sortModel={[{ field: 'stop_number', sort: 'desc' }]}
                            getRowId={(row) => row.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    allRouteDetailsData: state.loadValidationDashboard.routeDetailsData,
    filters: state.loadValidationDashboard.filters,
    filterOptions: state.loadValidationDashboard.filterOptions,
    customers: state.edgePCs.customers || []
});

const mapDispatchToProps = (dispatch) => ({
    updateFilters: (filterType, value) => dispatch(Actions.UPDATE_LVD_FILTERS(filterType, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteDetailsGridPanel);
